import { parseJsonSafely } from "@/utils/GlobalJavascriptFunction";
function getLocationParams(search) {
  return new URLSearchParams(search);
}
export default function getInAppSource(req) {
  if (__IS_SSR__ && req) {
    var search = req.originalUrl.includes('?') ? req.originalUrl.split('?')[1] : '';
    var _params = getLocationParams(search);
    return parseJsonSafely(_params.get("inapp_source")) || null;
  }
  if (typeof window === "undefined" || !window.location) {
    return null;
  }
  var params = getLocationParams(window.location.search);
  return parseJsonSafely(params.get("inapp_source")) || null;
}